import React from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

const FeesTable = ({
  feeStructures,
  totalRecords,
  onPage,
  onSort,
  lazyParams,
  loading,
  actionsBody
}) => {
  return (
    <div className="bg-white/80 backdrop-blur-sm rounded-xl border border-white/20 shadow-xl overflow-hidden flex flex-col flex-1 min-h-0 mt-2">
      <div className="border-b border-gray-100 p-4 flex-shrink-0">
        <div className="space-y-3">
          <div className="flex justify-between">
            <h3 className="text-2xl font-bold text-gray-900">Fee Structures Directory</h3>
            {totalRecords > 0 ? (
              <span className="flex items-center px-3 py-1 bg-green-50 text-green-700 rounded-full border border-green-200 text-sm">
                <i className="pi pi-check-circle mr-2"></i>
                {feeStructures.length} of {totalRecords} Fee Structures
              </span>
            ) : (
              <span className="flex items-center px-3 py-1 bg-orange-50 text-orange-700 rounded-full border border-orange-200 text-sm">
                <i className="pi pi-exclamation-triangle mr-2"></i>
                No fee structures found
              </span>
            )}
          </div>
        </div>
      </div>

      <div className="p-4 overflow-y-auto flex-1 min-h-0">
        {loading ? (
          <div className="flex justify-center items-center py-12">
            <div className="flex flex-col items-center space-y-4">
              <div className="relative">
                <div className="w-16 h-16 border-4 border-blue-200 border-t-blue-600 rounded-full animate-spin"></div>
                {/* <div className="absolute inset-0 flex items-center justify-center">
                  <i className="pi pi-dollar text-blue-600 text-xl"></i>
                </div> */}
              </div>
              <div className="flex flex-col items-center">
                <span className="text-lg font-bold text-gray-900">Loading Fee Structures</span>
                <span className="text-sm text-gray-500 italic">Please wait while we fetch the directory...</span>
              </div>
            </div>
          </div>
        ) : (
          <DataTable value={feeStructures} lazy dataKey="id" paginator first={(lazyParams.page - 1) * lazyParams.rows} rows={lazyParams.rows} totalRecords={totalRecords}
            onPage={onPage} onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder} loading={loading}
            emptyMessage={<div className="text-center py-8">No fee structures found</div>} rowsPerPageOptions={[5, 10, 25, 50]}
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} fee structures"
            responsiveLayout="scroll" showGridlines stripedRows size="small">
            <Column field="feeType" header={<div className="flex items-center text-xs"><i className="pi pi-tag mr-1 text-xs"></i>Fee Type</div>} sortable />
            <Column field="amount" header={<div className="flex items-center text-xs"><i className="mr-1 text-xs"></i>Amount</div>} sortable />
            <Column field="className" header={<div className="flex items-center text-xs"><i className="pi pi-book mr-1 text-xs"></i>Class</div>} sortable />
            <Column field="description" header={<div className="flex items-center text-xs"><i className="pi pi-info-circle mr-1 text-xs"></i>Description</div>} />
            <Column header={<div className="flex items-center text-xs"><i className="pi pi-cog mr-1 text-xs"></i>Actions</div>} body={actionsBody} style={{ width: '12rem' }} />
          </DataTable>
        )}
      </div>
    </div>
  );
};

export default FeesTable;
